import {getCafe} from "./getCafe";

export function priceText(price,currency = getCafe("currency"),fixed=2) {
    return parseFloat(price).toFixed(fixed).toString()+""+currency;
}

